export default {"src":"/_next/static/media/google.c961d659.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};